import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Single page web apps: the worst of both worlds",
  "description": "",
  "published": "2012-11-12T00:00:00.000Z",
  "redirect_from": ["/blog/single-page-web-apps-the-worst-of-both-worlds/swizec/5538"],
  "categories": "Uncategorized",
  "hero": "./img/comics-server_attention_span.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "740px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f4aec7009a0f7f91d24cd187d61ad476/50383/comics-server_attention_span.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.905829596412556%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'108\\'%20viewBox=\\'0%200%20400%20108\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2054v54h53V1L26%200H0v54M56%201v54l1%2053h52V0H83L56%201m57%2053v54h73V0h-73v54m77%200v54h73V0h-73v54m76%200v54h62V0h-62v54m66%200v54h68V0h-68v54M1%2054v53h50V1H1v53m57%200v53h50V1H58v53m56-26v27h22l35%201h14V1h-71v27m77%203v30h24l36-1h11V1h-71v30m77%2023v53h59V1h-59v53m65%200c0%2052%200%2053%202%2053s2-1%202-26V54l15-1c14-1%2015-1%2014%201%200%203-1%203-13%204h-10v6h9c8%200%2010-1%2010-2%201-1%201-1%203%201l17%201c18-1%2017-1%2017-5v-3h-12c-14%201-18%201-17-2%200-2%202-2%2015-2l14-1V1h-66v53M79%208c0%202%200%203%202%203V6v1l1%203h10l2-1h1v1l3%201%204-1h1c1%201%202%200%202-2V5h-6c-5%200-6%201-6%203h-1c-1-2-3-3-3%200l-1%201V5l-2%201h-2l-3-1c-2%200-2%200-2%203M16%2037v66h2l10%201h8l3-4%204-4V67l1-29-4-1H16m47%205c-3%203%200%2031%205%2044%202%206%204%206%2014%206%2013-1%2013-2%209-15l-2-16-1-7-2-6c0-7%200-7-12-7-9-1-10-1-11%201m3%206c0%203%204%2027%206%2031l1%206h9l8-1-1-7-3-13-2-6V48H66m221%203l-2%202-2%2012c-4%2015-5%2029-3%2031%201%202%2020%207%2021%206v-8c1-7%203-22%205-26l2-10c1-2-1-3-18-8l-3%201m2%208c-2%206-5%2026-3%2022l1-1v2c-1%201-1%201%202%201s3%200%201-1h7c2%200%202%201%201%203-1%208-1%208-3%208-4%200-4%202-1%202%205%201%205%201%205-2l2-14c2-10%202-11%201-11v-1c2%200%203-2%203-4l-9-3c-2%200-1%202%201%203s2%201-1%201h-3l-1-1c-1%200-2%201-1%202h3c3%200%203%200%203%202%200%201%200%202-1%201l-1%201h-2c-3-1-4-2-4-5%200-4%200-4%202-4%204%201%204%200%201-2-2-1-3-1-3%201m-98%2038v10h71V88h-4l-22-1h-17l-14-1h-14v11m153%203v5l5-1a153%20153%200%200120-1h4l-6-2-14-4-9-3v6m-230%203v4h71v-3c0-3%200-3-5-3l-36-1h-30v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f4aec7009a0f7f91d24cd187d61ad476/ca0a1/comics-server_attention_span.webp 223w", "/static/f4aec7009a0f7f91d24cd187d61ad476/75680/comics-server_attention_span.webp 445w", "/static/f4aec7009a0f7f91d24cd187d61ad476/ca4a8/comics-server_attention_span.webp 740w"],
                "sizes": "(max-width: 740px) 100vw, 740px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f4aec7009a0f7f91d24cd187d61ad476/e92b6/comics-server_attention_span.png 223w", "/static/f4aec7009a0f7f91d24cd187d61ad476/e66bf/comics-server_attention_span.png 445w", "/static/f4aec7009a0f7f91d24cd187d61ad476/50383/comics-server_attention_span.png 740w"],
                "sizes": "(max-width: 740px) 100vw, 740px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f4aec7009a0f7f91d24cd187d61ad476/50383/comics-server_attention_span.png",
                "alt": "Server memory span, xkcd",
                "title": "Server memory span, xkcd",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Server memory span, xkcd`}</figcaption>{`
  `}</figure></p>
    <p>{`Single `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Web_page",
        "title": "Web page"
      }}>{`page`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Web_application",
        "title": "Web application"
      }}>{`web apps`}</a>{` are the promised land of modern javascript MVC frameworks like Backbone or Ember.`}</p>
    <p>{`Deliver a dynamic experience right to the browser, they said, use the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Server_%28computing%29",
        "title": "Server (computing)"
      }}>{`server`}</a>{` like a smart database, they said. Your site will be quicker and your users will love it, they said. Page loads in the blink of a second, static content via `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Content_delivery_network",
        "title": "Content delivery network"
      }}>{`CDN`}</a>{`, no more flickery full page reloads ... they said.`}</p>
    <p>{`All of those promises are true.`}</p>
    <p>{`Servers should handle data. They're very good at that and having a central authority to handle `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Data_consistency",
        "title": "Data consistency"
      }}>{`data consistency`}</a>{` amongst clients is perhaps the simplest distributed system architecture one can think of. Sure, it gets a bit complicate when `}<em parentName="p">{`"A server"`}</em>{` becomes a few tens of boxes spread out in data centers across the globe, but that's still not the client's problem.`}</p>
    <p>{`Conversely, clients are `}<em parentName="p">{`exceptionally`}</em>{` good at presenting data! It's practically all they do. They give some data to the user, then they sit quietly in the user's face `}<del parentName="p">{`waiting`}</del>{`screaming to be poked so they can send some changes back to the server.`}</p>
    <p>{`This separation makes sense.`}</p>
    <p>{`Makes organising teams easier, separating talent becomes a walk in the park, it's even friendlier for the user who doesn't have to wait for a signal to travel halfway around the world just to open a menu!`}</p>
    <p>{`Win-win-win!`}</p>
    <h2 {...{
      "id": "not-really"
    }}>{`Not really.`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "499px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c6176b62502ab4689b382c951b037fcc/5cb26/8438-7997838999_ab00c71330.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20134v133h36v-6a3056%203056%200%2001-9-153l-3-76h21v-7h17c19%200%2020%200%2020%204s2%204%2055%205a13323%2013323%200%2001224%206l2%2015%203%2040a947%20947%200%20019%20139l1-2v2c0%202%200%203-5%203a4545%204545%200%2001-220%2026l-34%204h284V0H0v134M23%208v9l1%206h14l48%201a19151%2019151%200%2001250%207l25%201v-3l-3-5-1-2%202%201h1c0-2-2-2-9-2a10166%2010166%200%2000-249-11L65%209c-1-4-3-4-22-4H24l-1%203m3%2039a2458%202458%200%20007%20126%2069581%2069581%200%20004%2085c0%206%200%206%2010%205l52-5%20239-26v-13a46229%2046229%200%2001-12-174%2010719%2010719%200%2000-205-3H96l20%201%2021%201v6l1%207v-7l1-6h49v9l1%208h-50v-3l-1-2v5H83l-55-1V43l22-1%2023-1H26v6m163-1l1%209v6h47l-1-8v-8l-24-1h-23v2m48%205a1046%201046%200%20016%2080%2065208%2065208%200%20019%20109l22-2%2020-2v-8a598%20598%200%20010-14l1%2021h3l39-4-1-24a146474%20146474%200%2000-12-155v-5h-3a225%20225%200%2000-38%201l2%2026a35591%2035591%200%2000-4-26c0-2-8-3-30-3h-14v6m7%2035c-1%202-1%2010%201%2011l-1%202c-1%201-1%201%201%201v2l-1%201%202%201-1%201h-1c0%201%201%202%203%201l2%201h13c20%200%2019%200%2019-7l-1-7-1-3c1-2%200-2-2-2l-2%201h-4l-2%201c0%202-1%201-3-1h-6l-8-2-7-1h-1m8%2041l2%208v3l1-4v5l1%209%201-8c0-9%201-8%201%201%200%204%201%206%202%206v-1l2-3c1-2%201-2-6-15l-1-4c1%200%200-2-2-2l-1%205m51%201c-8%208-5%2022%206%2023l4-1h-3c-2%200-2%200-2-3%201-5%203-7%205-6%202%200%202%200%201-1-2-2-3-4%200-4l1-1c0-3%203%203%203%206s0%204%201%203h1c1%201%201-1%201-4%200-4%200-5-1-4v-1l-1-2v-1c0-1-2-4-4-3v-1c2-2-10-3-12%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c6176b62502ab4689b382c951b037fcc/ca0a1/8438-7997838999_ab00c71330.webp 223w", "/static/c6176b62502ab4689b382c951b037fcc/75680/8438-7997838999_ab00c71330.webp 445w", "/static/c6176b62502ab4689b382c951b037fcc/f002d/8438-7997838999_ab00c71330.webp 499w"],
                "sizes": "(max-width: 499px) 100vw, 499px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c6176b62502ab4689b382c951b037fcc/853b2/8438-7997838999_ab00c71330.jpg 223w", "/static/c6176b62502ab4689b382c951b037fcc/0a4fe/8438-7997838999_ab00c71330.jpg 445w", "/static/c6176b62502ab4689b382c951b037fcc/5cb26/8438-7997838999_ab00c71330.jpg 499w"],
                "sizes": "(max-width: 499px) 100vw, 499px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c6176b62502ab4689b382c951b037fcc/5cb26/8438-7997838999_ab00c71330.jpg",
                "alt": "Trello - perhaps the best web app I've seen",
                "title": "Trello - perhaps the best web app I've seen",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Trello - perhaps the best web app I've seen`}</figcaption>{`
  `}</figure></p>
    <p>{`Good single page web apps are a bitch to develop. A bitch with a few screws loose, to put it mildly.`}</p>
    <p>{`In traditional web development the one thing you can count on is everything being stateless. A request comes in containing everything you need to know, `}<em parentName="p">{`maybe`}</em>{` you have to fetch a few things from a database. Once you've answered the request, that's it, you don't care about the client until a new request comes in.`}</p>
    <p>{`This is easy. Easy to reason about, easy to make robust, easy to test and easy to avoid strange errors. You're basically ensuring a clean slate `}<em parentName="p">{`every time`}</em>{`.`}</p>
    <p>{`In traditional app development, you know for a fact everything is `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/State_%28computer_science%29",
        "title": "State (computer science)"
      }}>{`stateful`}</a>{`. You keep things in memory and you `}<em parentName="p">{`know`}</em>{` that's where they will remain until the app is closed and reopened. Nothing will randomly go missing and nobody seriously expects you to maintain state across sessions.`}</p>
    <p>{`Yeah yeah, sometimes gunk can accumulate when an app is left running too long. A restart either of the machine or the app usually solves the problem and even though many apps and even OS's have started experimenting with cross-session state it still isn't expected.`}</p>
    <p>{`A lot of people don't even want to `}<em parentName="p">{`restore tabs`}</em>{`!`}</p>
    <p>{`This clear divide between websites and apps helps in a lot of ways. Mostly it separates developers into those who don't have a problem re-imagining their universe around every request from those who prefer dealing with accumulating memory gunk.`}</p>
    <p>{`And then come modern web apps. Sitting confusingly on the fence between both worlds.`}</p>
    <p>{`Very simple in theory - the server is stateless and the frontend is stateful.`}</p>
    <p>{`But think about it. The frontend is stateful in the sense that very complex things can happen when the user clicks around. Data changes in memory and we expect the data to stay there, javascript being asynchronous aaaaalmost creates all the same problems traditional developers deal with in regards to multi-threaded code and it's very easy to accumulate all that gunk and start producing some `}<em parentName="p">{`very`}</em>{` strange errors.`}</p>
    <p>{`Then your user clicks refresh.`}</p>
    <p>{`Sometimes right after losing wi-fi signal in the middle of sending a request to the server ... or they closed the browser. Maybe it's not even the same user because they shared a link!`}</p>
    <p>{`Bang! Your app stateful just lost state.`}</p>
    <p>{`After a refresh the user expects to see exactly the same things they saw before. That's how the web works, right? You click around and you send a link to somebody and `}<em parentName="p">{`it's the same thing`}</em>{`. You don't expect to sometimes get the homepage and sometimes a blog post when going to `}<em parentName="p">{`/blog/some-title-of-a-post`}</em></p>
    <p>{`As developers we've found ourselves in a situation where we must assume our app is both stateless `}<strong parentName="p">{`and `}</strong>{`stateful. Every `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Uniform_Resource_Locator",
        "title": "Uniform Resource Locator"
      }}>{`URL`}</a>{` still points to a unique page, but if you got there after a reload, all the models must be refetched from server - preferably the server would bootstrap them into place - all open sockets must be re-established and a bunch of other minor things have to be taken care of.`}</p>
    <p>{`All in all, you get at least double of the complexity and for what? A shinier and smoother experience for the user ... which is exactly what we want.`}</p>
    <p>{`I would love to propose a good solution for this problem. But I can't. I am left sitting here, wondering, `}<em parentName="p">{`hoping`}</em>{` for a humane solution to this conundrum. My Google searches are coming up short.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/13323384/web-app-development-questions"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_114_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/13323384/web-app-development-questions"
        }}>{`Web app development questions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.i-programmer.info/professional-programmer/i-programmer/4982-the-disasterous-fragmentation-of-web-apps.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_128_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.i-programmer.info/professional-programmer/i-programmer/4982-the-disasterous-fragmentation-of-web-apps.html"
        }}>{`The Disastrous Fragmentation Of Web Apps`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.dynatrace.com/2012/09/26/why-page-size-matters-even-more-for-mobile-web-apps/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_74_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.dynatrace.com/2012/09/26/why-page-size-matters-even-more-for-mobile-web-apps/"
        }}>{`Why Page Size Matters even more for Mobile Web Apps`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://betakit.com/2012/10/31/mention-launches-social-media-and-web-monitoring-app-to-take-on-google-alerts"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/122561695_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://betakit.com/2012/10/31/mention-launches-social-media-and-web-monitoring-app-to-take-on-google-alerts"
        }}>{`Mention Launches Social Media and Web Monitoring App to Take On Google Alerts`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e0b4d69c-e979-45b9-a912-6cbeb3833898",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      